import axios from './axios'

export const sendTestEmail = (data) =>
  axios.post('/mailchimp/send-mailchimp-test-mail', data)

export const sendEmail = (data) =>
  axios.post('/mailchimp/send-mailchimp-mail', data)
